import * as actions from './actionTypes';
import language from '../app/lang.json'

// default state in state.json
export default (state = {}, action) => {
  switch (action.type) {
    case actions.RESULT:
      return Object.assign({}, state, {result: action.payload})
    case actions.RESET:
      return Object.assign({}, state, {qid: 0, result: -1})
    case actions.PREV:
      if (state.qid == 0)
        return state
      return Object.assign({}, state, {qid: state.qid-1, result: -1})
    case actions.NEXT:
      if (state.qid == state.questions.length - 1)
        return state
      return Object.assign({}, state, {qid: state.qid+1, result: -1})
    case actions.LANG:
      let newlang = language[action.payload]
      return Object.assign({}, state, {questions: newlang.questions, answers: newlang.answers})
    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/questions/reducer.js